import type { MatchReportType, ReportType } from 'src/types/report';

export const TITLE_TRANSLATION_KEYS: Record<ReportType | MatchReportType, string> = {
  VISUAL_ABUSE: 'REPORT_REASON_VISUAL_ABUSE_TITLE',
  VERBAL_ABUSE: 'REPORT_REASON_VERBAL_ABUSE_TITLE',
  CHILD_AGE_ABUSE: 'REPORT_REASON_CHILD_AGE_ABUSE_TITLE',
  VIDEO_PROFILE_ABUSE: 'REPORT_REASON_VIDEO_PROFILE_ABUSE_TITLE',
  FAKE_GENDER_ABUSE: 'REPORT_REASON_FAKE_GENDER_ABUSE_TITLE',
  DSA_ILLEGAL_CONTENT: 'REPORT_REASON_DSA_ILLEGAL_CONTENT_TITLE',

  IMAGE_PROFILE_ABUSE: 'REPORT_REASON_IMAGE_PROFILE_ABUSE_TITLE',
  BIO_NICKNAME_ABUSE: 'REPORT_REASON_BIO_NICKNAME_ABUSE_TITLE',
  UNDERAGE_USER: 'REPORT_REASON_UNDERAGE_USER_TITLE',
  OTHER_ABUSE: 'REPORT_REASON_OTHER_ABUSE_TITLE',
};

export const DESC_TRANSLATION_KEYS: Record<ReportType | MatchReportType, string | null> = {
  VISUAL_ABUSE: 'REPORT_REASON_VISUAL_ABUSE_DESC',
  VERBAL_ABUSE: 'REPORT_REASON_VERBAL_ABUSE_DESC',
  CHILD_AGE_ABUSE: 'REPORT_REASON_CHILD_AGE_ABUSE_DESC',
  VIDEO_PROFILE_ABUSE: 'REPORT_REASON_VIDEO_PROFILE_ABUSE_DESC',
  FAKE_GENDER_ABUSE: 'REPORT_REASON_FAKE_GENDER_ABUSE_DESC',
  DSA_ILLEGAL_CONTENT: 'REPORT_REASON_DSA_ILLEGAL_CONTENT_DESC',

  IMAGE_PROFILE_ABUSE: null,
  BIO_NICKNAME_ABUSE: 'REPORT_REASON_BIO_NICKNAME_ABUSE_DESC',
  UNDERAGE_USER: null,
  OTHER_ABUSE: 'REPORT_ABUSE_BEHAVIOR',
};
